import { createSelector } from 'reselect'

import {
  props,
  prop,
  entity,
  networkProps,
  routeParams,
  networkErrors,
  networkLoading,
} from './utils'

import settings from 'settings'
import project from './project'

const store = state => state.resource
const treeCollection = entity({
  baseSelector: prop(store, 'tree'),
  entityName: 'resource',
})
const listCollection = entity({
  baseSelector: prop(store, 'list'),
  entityName: 'resource',
})
const finderListCollection = entity({
  baseSelector: prop(store, 'finderList'),
  entityName: 'resource',
})

const tree = createSelector(
  treeCollection.list,
  (list) => {
    const sections = {}
    const children = {}

    list.forEach(item => { 
      if(item.parent) {
        const parentChildren = children[item.parent] || []
        parentChildren.push(item.id)
        children[item.parent] = parentChildren
      }
      else {
        const section = sections[item.section] || []
        section.push(item.id)
        sections[item.section] = section
      }
    })

    return {
      sections,
      children,
    }
  }
)

const finderLocation = prop(store, 'finderLocation')
const finderParentId = createSelector(
  finderLocation,
  (location) => location.parentid,
)

const parentId = createSelector(
  routeParams,
  (params) => params.parentid,
)

const pathSelector = (items, folderId) => {
  const pathItems = []
  if(folderId == 'root') return pathItems
  let currentItem = items[folderId]
  if(!currentItem) return pathItems

  while(currentItem) {
    pathItems.unshift(currentItem)
    currentItem = items[currentItem.parent]
  }
  return pathItems
}

const folderPath = createSelector(
  treeCollection.entities,
  parentId,
  pathSelector,
)

const finderFolderPath = createSelector(
  treeCollection.entities,
  finderParentId,
  pathSelector,
)

const schemas = createSelector(
  project.activeProject,
  (project) => {
    if(!project) return {}
    return settings.resourceSchemas(project)
  },
)

const NETWORK_NAMES = networkProps('resource', [
  'tree',
  'list',
  'get',
  'create',
  'save',
  'delete',
])

export default {
  store,
  errors: props(networkErrors, NETWORK_NAMES),
  loading: props(networkLoading, NETWORK_NAMES),
  treeCollection,
  listCollection,
  finderListCollection,
  tree,
  folderPath,
  finderFolderPath,
  parentId,
  schemas,
  ...props(store, [
    'search',
    'finderSearch',
    'finderLocation',
    'displayAmount',
    'displayTimeUnit',
    'clipboard',
  ]),
}
